import { SourceType } from '../types/core'
import { CitationData } from '../types/form'
import {
  unmountFormPageEvents,
  legacyJs,
  submitForm as submitFormLegacy,
} from './formLegacy'
import { appScroll } from './scroll'
import { sourceTypeById } from './sourceTypes'

interface FillFormArgs {
  style: string
  citation: any
  theme?: any
  onChangeSourceType: (sourceType: SourceType) => void
  onUserClickAddAnnotationCTA: () => void
  onUserClickAddContributorsCTA: () => void
}

export const fillForm = ({
  style,
  citation,
  theme,
  onChangeSourceType,
  onUserClickAddAnnotationCTA,
  onUserClickAddContributorsCTA,
}: FillFormArgs): void => {
  /**
   *  legacy form js sets up a bunch of delegated events on the body of the page every
   *    time the fillForm function runs, make sure to clear them out
   */
  unmountFormPageEvents()

  // legacy form js exposes a method that allows us to prepopulate
  // some of the form fields with data
  const handleChangeSourceType = (sourceTypeId: string) => {
    const sourceType = sourceTypeById(sourceTypeId)
    if (sourceType) onChangeSourceType(sourceType)
  }

  legacyJs({
    style,
    citation,
    theme,
    onChangeSourceType: handleChangeSourceType,
    onUserClickAddAnnotationCTA,
    onUserClickAddContributorsCTA,
  })
}

export const submitForm = (
  onComplete: (
    citation: CitationData,
    initialCitation: any,
    annotationText?: string
  ) => void
): void => {
  appScroll({ top: 0, left: 0, behavior: 'auto' })
  submitFormLegacy({ onComplete })
}

export { formDataToJson as formDataToJsonLegacy } from './formLegacy'
